// extracted by mini-css-extract-plugin
module.exports = {"dates":"billingDetail_dates__3yeuW"};